import { apiClient } from '@/shared/api';

import type {
  CatalogLanguage,
  CatalogLanguageCreateRequest,
  CatalogLanguageUpdateRequest,
} from '../model/types';

const BASE = '/api/v1/catalog/languages';

/** List the tenant's catalog language registry (epic-catalog-004, user-story-catalog-006). */
export const listCatalogLanguages = async (): Promise<CatalogLanguage[]> =>
  (await apiClient.get<CatalogLanguage[]>(BASE)).data;

/** The tenant's first added language always becomes the default, regardless of `makeDefault`. */
export const addCatalogLanguage = async (
  body: CatalogLanguageCreateRequest,
): Promise<CatalogLanguage> => (await apiClient.post<CatalogLanguage>(BASE, body)).data;

export const updateCatalogLanguage = async (
  locale: string,
  body: CatalogLanguageUpdateRequest,
): Promise<CatalogLanguage> =>
  (await apiClient.patch<CatalogLanguage>(`${BASE}/${encodeURIComponent(locale)}`, body)).data;

/** Rejected with `409` for the tenant's last remaining language, or its current default. */
export const deleteCatalogLanguage = async (locale: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${encodeURIComponent(locale)}`);
};
